import { STATEMENT_REAUTHORIZATION_FEATURE } from '@xbcb/feature-flags';
import { uiStageToBackendStage } from '@xbcb/ui-types';
import { Stage } from '@xbcb/shared-types';
import { getEnv } from '@xbcb/ui-utils';
import { CurrentUser } from 'libs/hooks';

const statementReauthorizationTeamMap = {
  [Stage.ALPHA]: '',
  [Stage.BRAVO]: '',
  [Stage.BETA]: '',
  [Stage.GAMMA]: 'businessSupportTeam_fcc82b45-e751-46ad-8eef-28eee1bdc1f3',
  [Stage.PROD]: 'businessSupportTeam_812dedb8-b9f4-417b-9bdc-14c993b8f56d',
};

export const canAccessStatementReauthorization = (
  currentUser: CurrentUser,
): boolean => {
  const { stage } = getEnv();
  const backendStage = uiStageToBackendStage[stage];
  const requiredTeamId = statementReauthorizationTeamMap[backendStage];

  if (requiredTeamId) {
    const hasAllowedTeam = currentUser.businessSupportTeams?.nodes?.some(
      (team) => team.id === requiredTeamId,
    );
    if (!hasAllowedTeam) {
      return false;
    }
  }

  const context = {
    stage: backendStage,
    team: requiredTeamId || '',
  };

  return STATEMENT_REAUTHORIZATION_FEATURE.isEnabled(
    'STATEMENT_REAUTHORIZATION_FEATURE',
    context,
  );
};
